import { useModals } from "@/router";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

interface ModalDeleteProps {
  title: string
  content: string
  onAccept: (data: object) => void
}

export default function ModelDelete(props: ModalDeleteProps) {
  const {t} = useTranslation()
  const localtion = useLocation()
  const navigate = useNavigate()

  const handelClose = () => {
    navigate(localtion)
  }

  return (
    <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
      <div className="w-full max-w-142.5 rounded-lg bg-white py-12 px-8 text-center dark:bg-boxdark md:py-15 md:px-17.5">
        <span className="mx-auto inline-block">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.1" width="60" height="60" rx="30" fill="#DC2626"></rect>
            <path d="M30 27.2498V29.9998V27.2498ZM30 35.4999H30.0134H30ZM20.6914 41H39.3086C41.3778 41 42.6704 38.7078 41.6358 36.8749L32.3272 20.3747C31.2926 18.5418 28.7074 18.5418 27.6728 20.3747L18.3642 36.8749C17.3296 38.7078 18.6222 41 20.6914 41Z" stroke="#DC2626" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </span>
        <h4 className="mt-5.5 pb-2 text-xl font-bold text-black dark:text-white sm:text-2xl">
          {props.title}
        </h4>
        <p className="mb-10 font-medium dark:text-white">
          {props.content}
        </p>
        <div className="-mx-3 flex flex-row gap-y-4">
          <div className="w-full px-3 2xsm:w-1/2">
            <button onClick={handelClose} className="block w-full rounded border border-gray bg-gray p-3 text-center font-medium text-black transition hover:bg-opacity-90">
              {t("modal.cancel")}
            </button>
          </div>
          <div className="w-full px-3 2xsm:w-1/2">
            <button onClick={props.onAccept} className="block w-full rounded border border-meta-1 bg-meta-1 p-3 text-center font-medium text-white transition hover:bg-opacity-90">
              {t("modal.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
